jQuery(document).ready(function ($) {

  if($(".home-list-icon-cus")) {
    $(".home-list-icon-cus").slick({
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 4000,
          settings: "unslick",
        },
        {
          breakpoint: 991,
          settings: {
            dot: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            dot: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

    if($(".home-text-top .multicolumn-list")) {
    $(".home-text-top .multicolumn-list").slick({
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 4000,
          settings: "unslick",
        },
        {
          breakpoint: 991,
          settings: {
            dot: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            dot: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }


   if($(".slider-product-collection")) {
    $(".slider-product-collection").slick({
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
      dots: false,
      arrows: false,
      //  useTransform: false,
 prevArrow: 
          '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><rect width="44" height="44" fill="#000000"/><path d="M10 22L28 11.6077L28 32.3923L10 22Z" fill="white"/></svg></div>',
      nextArrow:
          '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><rect width="44" height="44" transform="matrix(-1 0 0 1 44 0)" fill="black"/><path d="M34 22L16 11.6077L16 32.3923L34 22Z" fill="white"/></svg></div>',
      responsive: [
        {
          breakpoint: 4000,
           settings: {
            dot: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 2000,
           settings: {
            dot: false,
             arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 991,
           settings: {
            dot: false,
             arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            dot: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 2,
             centerMode: true
          },
        },
      ],
    });
  }


       if($(".discover-our-best-style slider-component ul.product-grid")) {
    $(".discover-our-best-style slider-component ul.product-grid").slick({
          centerMode: true,
      centerPadding: '0px',
      slidesToShow: 4,
      focusOnSelect: true,
      dots: false,
      infinite: true,

      prevArrow:
          '<div class="slick-prev-cs"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 5L5 12L12 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      nextArrow:
          '<div class="slick-next-cs"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12H19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 5L19 12L12 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            dot: true,
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
            dot: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

    


  

      if($(".partner-style .multicolumn-list")) {
    $(".partner-style .multicolumn-list").slick({
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 4000,
          settings: "unslick",
        },
        {
          breakpoint: 991,
          settings: {
            dot: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            dot: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  }

     if($(".hear-review-slick")) {
    $(".hear-review-slick").slick({
          centerMode: true,
      centerPadding: '0px',
      slidesToShow: 3,
      focusOnSelect: true,
      dots: false,
      infinite: true,
      prevArrow:
          '<div class="slick-prev-cs"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 5L5 12L12 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      nextArrow:
          '<div class="slick-next-cs"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12H19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 5L19 12L12 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            dot: true,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            dot: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
  
   if($(".section-best-seller slider-component .product-grid")) {
    $(".section-best-seller slider-component .product-grid").slick({
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 4000,
           settings: {
             dots: true,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 991,
           settings: {
            dots: true,
      arrows: false,
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
           dots: true,
          arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
      arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }


 if($(".box-main-recommended")) {
    $(".box-main-recommended").slick({
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
      dots: false,
      arrows: false,
 prevArrow: 
          '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M10.625 12.75L6.375 8.5L10.625 4.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      nextArrow:
          '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none"><path d="M1.375 9.75L5.625 5.5L1.375 1.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      responsive: [
        {
          breakpoint: 4000,
           settings: {
            dot: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 2000,
           settings: {
            dot: false,
             arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
           settings: {
            dot: false,
             arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            dot: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
             dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,

          },
        },
      ],
    });
  }


  

      function backToTop() {
        const backTop = $(".back-top-single");
        const footer = $("footer.footer");
        $(window).scroll(function () {
            const scrollPosition = $(this).scrollTop();
            const footerTop = footer.offset().top;
            const footerHeight = footer.outerHeight();
            const windowHeight = $(window).height();
            if ((scrollPosition > footerTop + footerHeight - windowHeight - footerHeight) || scrollPosition < 800) {
                backTop.css({display: "none",})
            } else {
                backTop.css({display: "block",})
            }
        })
    }

    backToTop();
  

 $('.scrollToTop').click(function () {
    $('html, body').animate({scrollTop: 0}, 700);
    return !1
});
});




